import fs from 'fs'
import path from 'path'

type FrameworkType = Record<string, { name: string, version: string }>

const pkg: Record<string, string> = JSON.parse(fs.readFileSync(path.resolve(process.cwd() + '/package.json'), 'utf-8').toString())
const framework: FrameworkType = {}

export default (): FrameworkType => {
  const frameworks: string[] = ['vue', 'react', 'svelte']
  let i = 0, o = 0

  const packages = Object.keys(pkg.dependencies)

  while (i < frameworks.length) {
    while (o < packages.length) {
      if (frameworks.includes(packages[o])) {
        Object.assign(framework, { name: packages[o] })
        Object.assign(framework, { version: pkg.dependencies[packages[o]] })
      }
      o++
    }
    i++
  }
  return framework
}
